import { render, staticRenderFns } from "./PlusSavingsBanner.vue?vue&type=template&id=e817b0b4&scoped=true&"
import script from "./PlusSavingsBanner.vue?vue&type=script&lang=js&"
export * from "./PlusSavingsBanner.vue?vue&type=script&lang=js&"
import style0 from "./PlusSavingsBanner.vue?vue&type=style&index=0&id=e817b0b4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e817b0b4",
  null
  
)

export default component.exports